// extracted by mini-css-extract-plugin
module.exports = {"tutoPanel":"tuto-panel_tutoPanel__2EkWD"};